import {downloadApk, inApp, isPWA, stopBeforeDownload} from '@/utils';
import React, {useEffect, useState} from 'react';
import CloseIcon from '../assets/icon/close.svg';
import {defaultApkPath} from '@/config';
import {Image} from '@/components-v2';
import {AnimatePresence, motion} from 'motion/react';

function HomeDownload() {
  const [pwaOpen, setPwaOpen] = useState(false);
  useEffect(() => {
    if (!inApp && !isPWA()) {
      if (defaultApkPath) {
        setPwaOpen(true);
      } else {
        window.addEventListener(
          'beforeinstallprompt',
          e => {
            (window as any).installPropt = e;
            setPwaOpen(true);
          },
          {once: true},
        );
      }
    }
  }, []);
  return (
    <div className="absolute bottom-[50px] left-1/2 -translate-x-1/2 z-10">
      <AnimatePresence>
        {pwaOpen && (
          <motion.div
            key="model"
            exit={{opacity: 0, scale: 0}}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            initial={{
              opacity: 0,
              scale: 0,
            }}
            className="h-9 px-4 py-2.5 bg-c1 min-w-max rounded-full text-white flex items-center justify-between gap-x-2">
            <div
              className="flex items-center justify-between gap-x-2"
              onClick={e => {
                if (defaultApkPath) {
                  if (!stopBeforeDownload()) {
                    downloadApk();
                  }
                } else if (e.target instanceof HTMLDivElement) {
                  (window as any).installPropt.prompt();
                }
                setPwaOpen(false);
              }}>
              <Image
                className="h-[1.75rem] w-[1.75rem] rounded"
                src="/assets/logo.png"
                alt="logo"
              />
              <div className="text-sm font-bold">Download APP</div>
            </div>
            <div className="w-[1px] h-6 bg-white opacity-50" />
            <div onClick={() => setPwaOpen(false)}>
              <CloseIcon size="1.125rem" color="var(--bg-color-lightGrey)" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default HomeDownload;
